import { Component } from "react";
import { nanoid } from "nanoid";
import { ContactForm } from "../ContactForm/ContactForm.jsx";
import { ContactList } from "../ContactList/ContactList.jsx";
import { Filter } from "../Filter/Filter.jsx";

import { Wrapper, Title, Subtitle } from "./Pnonebook.styled.js";
import { BsTelephonePlus } from "react-icons/bs";
import { RiContactsBook3Line } from "react-icons/ri";

export class Phonebook extends Component {
  state = {
    contacts: [
      { id: "id-1", name: "Ліанора Зефіра", number: "+380 97 345 78 21" },
      { id: "id-2", name: "Тавіан Орсен", number: "+380 66 512 44 99" },
      { id: "id-3", name: "Елісандра Флора", number: "+380 50 876 12 33" },
      { id: "id-4", name: "Ксанфей Морвін", number: "+380 63 998 55 77" },
      { id: "id-5", name: "Ауреліо Вейлан", number: "+380 68 234 90 11" },
    ],
    filter: "",
  };

  handleAddContact = (name, number) => {
    const isDuplicate = this.state.contacts.some(
      (contact) => contact.name.toLowerCase() === name.toLowerCase(),
    );

    if (isDuplicate) {
      alert(`${name} is already in contacts.`);
      return;
    }

    const newContact = { id: nanoid(), name, number };
    this.setState((previous) => ({
      contacts: [...previous.contacts, newContact],
    }));
  };

  handleDeleteContact = (id) => {
    this.setState((previous) => ({
      contacts: previous.contacts.filter((contact) => contact.id !== id),
    }));
  };

  handleFilterChange = (event) => {
    this.setState({ filter: event.target.value });
  };

  getFilteredContacts = () => {
    const { contacts, filter } = this.state;
    return contacts.filter((contact) =>
      contact.name.toLowerCase().includes(filter.toLowerCase()),
    );
  };

  render() {
    return (
      <Wrapper>
        <Title>
          Phonebook <BsTelephonePlus />
        </Title>
        <ContactForm onAddContact={this.handleAddContact} />

        <Subtitle>
          Contacts <RiContactsBook3Line />
        </Subtitle>
        <Filter value={this.state.filter} onChange={this.handleFilterChange} />
        <ContactList
          contacts={this.getFilteredContacts()}
          onDelete={this.handleDeleteContact}
        />
      </Wrapper>
    );
  }
}
